import React, { useEffect, useState } from 'react';
import {
  StyledTableCell,
  StyledTableRow,
} from '../../helpers/themes/TableTheme';
import { FormHelperText, IconButton, TextField } from '@mui/material';
import EastIcon from '@mui/icons-material/East';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SaveAsOutlinedIcon from '@mui/icons-material/SaveAsOutlined';

const EditShortcut = ({ element, onChange, error }) => {
  const [defaultValue, setDefaultValue] = useState(element);
  return (
    <>
      <StyledTableCell align="left">
        <TextField
          multiline
          fullWidth
          error={error}
          id="label"
          placeholder="Raccourci..."
          value={defaultValue?.label}
          onChange={(event) => {
            setDefaultValue({
              ...defaultValue,
              label: event.target.value,
            });
            onChange({
              ...defaultValue,
              label: event.target.value,
            });
          }}
        />
        {error && (
          <FormHelperText error>
            Le champ ne peut être vide mais doit être unique
          </FormHelperText>
        )}
      </StyledTableCell>
      <StyledTableCell align="center">
        <EastIcon />
      </StyledTableCell>
      <StyledTableCell align="left">
        <TextField
          multiline
          fullWidth
          error={error}
          id="content"
          placeholder="Texte..."
          value={defaultValue?.content}
          onChange={(event) => {
            setDefaultValue({
              ...defaultValue,
              content: event.target.value,
            });
            onChange({
              ...defaultValue,
              content: event.target.value,
            });
          }}
        />
        {error && (
          <FormHelperText error>Le champ ne peut être vide</FormHelperText>
        )}
      </StyledTableCell>
    </>
  );
};

export const ShortcutTable = ({
  data,
  onDelete,
  onEdit,
  isAdd,
  addError,
  newShortcut,
  setNewShortcut,
}) => {
  const [editID, setEditID] = useState(null);
  const [update, setUpdate] = useState({});
  const [error, setError] = useState(false);
  const handleSave = () => {
    console.log(update);
    if (!update?.label || !update?.content || !update?._id) {
      setError(true);
      return;
    }
    if (
      data?.shortcuts?.some(
        (item) =>
          item?.label === update?.label &&
          item?._id?.toString() !== update?._id?.toString()
      )
    ) {
      setError(true);
      return;
    }
    setError(false);
    onEdit(update);
    setEditID(null);
    setUpdate({});
  };

  const handleChange = (value, props) => {
    console.log(newShortcut);
    setNewShortcut({
      ...newShortcut,
      [props]: value,
    });
  };

  useEffect(() => {
    setError(false);
  }, [editID]);
  return (
    <>
      {data?.shortcuts?.map((element) => (
        <StyledTableRow key={element?._id}>
          {element?._id?.toString() === editID?.toString() ? (
            <EditShortcut
              element={element}
              error={error}
              onChange={(value) => setUpdate(value)}
            />
          ) : (
            <>
              <StyledTableCell align="left">{element?.label}</StyledTableCell>
              <StyledTableCell align="center">
                <EastIcon />
              </StyledTableCell>
              <StyledTableCell align="left">{element?.content}</StyledTableCell>
            </>
          )}
          {element?._id?.toString() === editID?.toString() ? (
            <StyledTableCell align="right">
              <IconButton onClick={handleSave}>
                <SaveAsOutlinedIcon color="success" />
              </IconButton>
              <IconButton onClick={() => setEditID(null)}>
                <EastIcon />
              </IconButton>
            </StyledTableCell>
          ) : (
            <StyledTableCell align="right">
              <IconButton onClick={() => setEditID(element?._id)}>
                <EditOutlinedIcon color="primary" />
              </IconButton>
              <IconButton onClick={() => onDelete(element?._id)}>
                <DeleteOutlinedIcon color="error" />
              </IconButton>
            </StyledTableCell>
          )}
        </StyledTableRow>
      ))}
      {isAdd && (
        <StyledTableRow key={1}>
          <StyledTableCell align="left">
            <TextField
              multiline
              fullWidth
              error={addError}
              id="label"
              placeholder="Raccourci..."
              value={newShortcut.label}
              onChange={(event) => handleChange(event.target.value, 'label')}
            />
            {addError && (
              <FormHelperText error>
                Le champ ne peut être vide mais doit être unique
              </FormHelperText>
            )}
          </StyledTableCell>
          <StyledTableCell align="center">
            <EastIcon />
          </StyledTableCell>
          <StyledTableCell align="left">
            <TextField
              multiline
              fullWidth
              error={addError}
              id="content"
              placeholder="Texte..."
              value={newShortcut.content}
              onChange={(event) => handleChange(event.target.value, 'content')}
            />
            {addError && (
              <FormHelperText error>Le champ ne peut être vide</FormHelperText>
            )}
          </StyledTableCell>
          <StyledTableCell />
        </StyledTableRow>
      )}
    </>
  );
};
